function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMhcPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.646,
    height: 52.689,
    viewBox: "0 0 49.646 52.689",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17265"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 6499",
    transform: "translate(17.73 22.1)",
    style: {
      fill: "#f37b89"
    },
    d: "M0 0h30.733v18.913H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16901"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 838",
    d: "M47.083 43.134h-8.1v-2.027h8.1a1.012 1.012 0 0 0 1.01-1.007V24.9a1.012 1.012 0 0 0-1.011-1.01h-8.1v-2.035h8.1a3.04 3.04 0 0 1 3.035 3.037V40.1a3.04 3.04 0 0 1-3.034 3.034zm-8.707-19.245h-.625a2.408 2.408 0 0 0-.837.152v-.16H19.747a1.012 1.012 0 0 0-1.011 1.01V40.1a1.012 1.012 0 0 0 1.011 1.011h17.168v-.181a2.4 2.4 0 0 0 .837.152h.625a2.413 2.413 0 0 0 .606-.08v.1h-.043v8.372a4.057 4.057 0 0 1-4.056 4.049H4.528a4.059 4.059 0 0 1-4.056-4.046V4.9A4.062 4.062 0 0 1 4.528.839h19.988a1.013 1.013 0 0 1 .73.31L38.656 15.1a1.011 1.011 0 0 1 .283.7v8.081h.043v.088a2.414 2.414 0 0 0-.606-.08zM24.767 3.574v11.45h11.009zm12.148 13.477h-13.16a1.013 1.013 0 0 1-1.013-1.013V2.865H4.528A2.035 2.035 0 0 0 2.5 4.9v44.577A2.031 2.031 0 0 0 4.528 51.5h30.355a2.03 2.03 0 0 0 2.032-2.023v-6.343H19.747a3.039 3.039 0 0 1-3.035-3.034V24.9a3.039 3.039 0 0 1 3.035-3.037h17.168z",
    transform: "translate(-.472 -.839)",
    style: {
      fillRule: "evenodd",
      fill: "#6f7e8e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12482",
    d: "M86.188 85.605h3.573v1.456h-3.573v4.121h-1.772V81.47h5.605v1.456h-3.833v2.68zm-4.982 4.352a6.485 6.485 0 0 1-4.4 1.325 19.4 19.4 0 0 1-2.392-.129V81.6a17.914 17.914 0 0 1 2.824-.2 5.91 5.91 0 0 1 3.962 1.124 4.342 4.342 0 0 1 1.52 3.576 5.027 5.027 0 0 1-1.513 3.857zm-3.8-7.176a5.672 5.672 0 0 0-1.21.1v6.946a6.608 6.608 0 0 0 .98.043c2.306.014 3.675-1.254 3.675-3.718.01-2.146-1.229-3.371-3.451-3.371zm-8.618 4.8a5.012 5.012 0 0 1-.865-.058v3.66h-1.76V81.6a15.358 15.358 0 0 1 2.709-.2 4.391 4.391 0 0 1 2.867.793 2.742 2.742 0 0 1 .952 2.147 2.944 2.944 0 0 1-.836 2.2 4.285 4.285 0 0 1-3.069 1.038zm.159-4.827a4.909 4.909 0 0 0-1.024.086v3.286a3.6 3.6 0 0 0 .865.072c1.326 0 2.133-.648 2.133-1.787-.003-1.082-.752-1.659-1.977-1.659z",
    transform: "translate(-44.761 -55.053)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMhcPdf);
export default __webpack_public_path__ + "static/media/mhc-pdf.3d9c6c34d9ca3015256f5780a3c233a9.svg";
export { ForwardRef as ReactComponent };